import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 1px 3px #00000029;
  background: #FFFFB5;
  padding: 20px;
  min-height: 40px;
  margin-bottom: 20px;
  border-radius: 10px;
  width: 100%;
`

export const ContentWrapper = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`

export const Content = styled.div`
  gap: 3px;
  display: flex;
  flex-direction: column;
`

export const ActionWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;

  > button {
    height: 36px;
    width: 139px;
  }

  @media (max-width: 768px) {
    justify-content: space-between;
  }
`